import BancaFarmaciListPage from "./pages/BancaFarmaciListPage.vue";
import BancaFarmaciViewPage from "./pages/BancaFarmaciViewPage.vue";

export default{BancaFarmaciListPage,BancaFarmaciViewPage}